export default "__VITE_ASSET__BPWyFB46__"